import { Navigate } from 'react-router-dom'
import ROUTES from '../../../assets/routes'
import { Box } from '@mui/material'
import { isAuthenticated } from '../../../util/authentication'
import { isEmbeddedModeSet } from '../../../util/general'
import PinSessionUnlockGate from './PinSessionUnlockGate'

const ProtectedRoute = ({ children }: any) => {
    const authenticated: boolean = isAuthenticated()

    // Host owns auth in embedded WebViews — never bounce to the web login page.
    if (!authenticated && !isEmbeddedModeSet()) {
        return <Navigate to={ROUTES.login} replace />
    }

    return (
        <PinSessionUnlockGate>
            <Box sx={{ width: '100%', height: '100%' }}>{children}</Box>
        </PinSessionUnlockGate>
    )
}

export default ProtectedRoute
